/* eslint-disable react/no-array-index-key */
import {
  Dispatch, SetStateAction, useEffect, useState,
} from 'react';
import RadioSearchOption from './RadioSearchOption';

type Props = {
  type: string;
  options: Record<string, string>[];
  filters: Record<string, string[]>;
  setFilters: Dispatch<SetStateAction<Record<string, string[]>>>;
  onClickItem?: any;
};

export function RadioSearchGroup({
  options, filters, setFilters, onClickItem, type,
}: Props): JSX.Element {
  const [checkedState, toggleCheckedState] = useState(filters[type]?.[0]);
  const handleSearch = (target: string): void => {
    if (target !== checkedState) {
      toggleCheckedState(target);
    }

    const newFilters = { ...filters };
    newFilters[type] = [target];

    setFilters(newFilters);
  };

  useEffect(() => {
    toggleCheckedState(filters[type]?.[0]);
  }, [filters[type]?.[0]]);

  return (
    <>
      {
        options.map((option, idx) => (
          <RadioSearchOption
            key={idx}
            option={option}
            handleSearch={handleSearch}
            checkedState={checkedState}
            onClick={onClickItem}
          />
        ))
      }
    </>
  );
}
